import { CircularProgress } from '@material-ui/core';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import React from 'react';

const BarChartScanit = (props) => {
	const { dataApproved, dataTotalScanits, initialDate, endDate, isLoading } = props;

	const formatDate = (dateToTransform) => {
		var date = new Date(dateToTransform);

		var monthNames = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		//var day = date.getUTCDate();
		var monthIndex = date.getUTCMonth();
		var year = date.getUTCFullYear();

		return monthNames[monthIndex] + ' ' + year;
	};

	let xAxisCategoriesApproved = [];
	let scanitsApproved = [];
	let totalScanits = [];

	if (isLoading === false) {
		for (const element in dataApproved) {
			if (dataApproved[element].initialDate >= initialDate && dataApproved[element].initialDate <= endDate) {
				const monthYear = formatDate(dataApproved[element].initialDate);

				xAxisCategoriesApproved.push(monthYear);
				scanitsApproved.push(dataApproved[element].nScanitsActual);
			}
		}

		for (const element in dataTotalScanits) {
			if (dataTotalScanits[element].initialDate >= initialDate && dataTotalScanits[element].initialDate <= endDate) {
				// const monthYear = formatDate(dataTotalScanits[element].initialDate);

				//xAxisCategoriesApproved.push(monthYear);
				totalScanits.push(dataTotalScanits[element].nScanitsActual);
			}
		}
	}

	let options;
	if (scanitsApproved.length > 0 && totalScanits.length > 0) {
		options = {
			chart: {
				type: 'line',
			},
			title: {
				text: 'Evolución Número de Scanits',
			},
			xAxis: {
				categories: xAxisCategoriesApproved,
				//allowDecimals: false,
			},
			series: [
				{
					name: 'Scanits Totales',
					type: 'column',
					data: totalScanits,
				},
				{
					name: 'Scanits Aprobados',
					type: 'column',
					data: scanitsApproved,
				},
			],
		};
	}

	return <React.Fragment>{isLoading ? <CircularProgress /> : <HighchartsReact highcharts={Highcharts} options={options} />}</React.Fragment>;
};

export default React.memo(BarChartScanit);
